module.exports = __webpack_public_path__ + "ba34f32cd18a4a343280855059ea990a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/makeup.png
// module id = 2855
// module chunks = 0